var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "to-fit-std-sizes" }, [
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c("frame-filters", {
          staticClass: "mb-3",
          model: {
            value: _vm.filters,
            callback: function ($$v) {
              _vm.filters = $$v
            },
            expression: "filters",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "container" },
      [
        _vm.size
          ? _c("frame-results", {
              staticClass: "mb-3",
              attrs: { filter: _vm.filters, "artwork-size": _vm.size },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }